import { createAction } from 'redux-actions';
import { pushModal } from '../../Modals/redux/actionCreators';
import { ModalType } from '../../Modals/redux/types';
export const openCommissionEditModal = (params)=>pushModal(ModalType.COMMISSION, {
        params,
        wrapInModal: false
    });
export const createCommission = createAction('@@COMMISSIONS.CREATE', (payload)=>payload);
export const updateCommission = createAction('@@COMMISSION.UPDATE', (payload)=>payload);
export const changeCommissionStatus = createAction('@@COMMISSION.CHANGE_STATUS', (payload)=>payload);
export const changeCommissionStatusSuccess = createAction('@@COMMISSION.CHANGE_STATUS_SUCCESS', (payload)=>payload);
export const toggleCommissionStatus = createAction('@@COMMISSION.TOGGLE_STATUS', (payload)=>payload);
export const updateSubmittingState = createAction('@@COMMISSION.UPDATE_SUBMITTING_STATE', ({ submittingState })=>({
        submittingState
    }));
export const updateSubmitErrorString = createAction('@@COMMISSION.UPDATE_SUBMIT_ERROR_STRING', ({ submitErrorString })=>({
        submitErrorString
    }));

//# sourceMappingURL=actionCreators.js.map